import React, { useState } from "react";
import Dialog from "../../../components/Dialog";
import HeaderTachModal from "./components/HeaderTachModal";
import InformationTach from "./components/InformationTach";
import CheckboxTach from "./components/CheckboxTach";
import JustifyTach from "./components/JustifyTach";
import ActionsTachModal from "./components/ActionsTachModal";
import GenericUtils from "../../../utils/GenericUtils";
import ModalCallback from "../../../model/ModalCallback";
import { useTachDocWorkflow } from "../../../context/TachDocumentContext";
import ModalViewTach from "./ModalViewTach";
import ModalConfirmAction from "./ModalConfirmAction";

type Modal = {
    open: boolean;
    onClose: (callback?: ModalCallback) => void;
    workflow: any;
    visibility?: boolean;
    cancelModal: boolean;
};

const ModalActionTach = ({
    open,
    onClose,
    workflow,
    visibility,
    cancelModal,
}: Modal) => {
    const [showDialog, setShowDialog] = useState(visibility ?? true);
    const [openViewTach, setOpenViewTach] = useState<boolean>(false);
    const [openConfirmModal, setOpenConfirmModal] = useState<boolean>(false);
    const [urlPdf, setUrlPdf] = useState<string>("");
    const user = GenericUtils.getUser();
    const { setCheck } = useTachDocWorkflow();

    const closeTachModal = () => {
        setCheck(false);
        onClose();
    };

    const handleOpenViewTach = (pathUrl: string) => {
        setUrlPdf(pathUrl);
        setShowDialog(false);
        setOpenViewTach(true);
    };

    const handleCloseViewTach = () => {
        setShowDialog(true);
        setOpenViewTach(false);
    };

    const handleOpenActionModal = () => {
        setShowDialog(false);
        setOpenConfirmModal(true);
    };

    const handleCloseActionModal = () => {
        setShowDialog(true);
        setOpenConfirmModal(false);
    };

    const dialogClass = `${showDialog ? "visible-dialog" : "hidden-dialog"}`;

    return (
        <Dialog
            openModal={open}
            onHide={closeTachModal}
            size="620px"
            className={dialogClass}
        >
            <HeaderTachModal
                title={cancelModal ? "Cancelar TACH" : "Aprovar TACH"}
                subtitle={
                    cancelModal
                        ? "É necessário justificar o cancelamento do TACH."
                        : "Confira os detalhes da distribuição da carga horária no TACH. Você pode aprová-las caso esteja de acordo."
                }
            />
            <InformationTach
                workflow={workflow}
                viewButton={handleOpenViewTach}
            />
            {cancelModal ? <JustifyTach /> : user.isDac && <JustifyTach />}
            {!cancelModal && <CheckboxTach />}
            <ActionsTachModal
                back={onClose}
                action={handleOpenActionModal}
                status={cancelModal}
            />
            {openViewTach && urlPdf.length > 0 && (
                <ModalViewTach
                    open={openViewTach}
                    onClose={handleCloseViewTach}
                    url={urlPdf}
                />
            )}
            {openConfirmModal && (
                <ModalConfirmAction
                    open={openConfirmModal}
                    onClose={handleCloseActionModal}
                    status={cancelModal}
                    endProcess={closeTachModal}
                    processId={workflow.workflowProcessoId}
                />
            )}
        </Dialog>
    );
};

export default ModalActionTach;
